export enum PromotionAllocationMethod {
  ACROSS = "ACROSS",
  EACH = "EACH",
}
